export const Notification = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 26C12.5316 27.7662 14.1131 29 16 29C17.8869 29 19.4684 27.7662 20 26" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 14C24 9.58172 20.4183 6 16 6C11.5817 6 8 9.58172 8 14V21L5 25H27L24 21V14Z" stroke="currentColor" stroke-width="2"/>
</svg>`;
